import axios from 'axios';

export default {
  addReward(projectId, data) {
    const reward = Object.assign({}, data);
    // reward price is stored on backend in the smallest sub-division of the currency, eg: 1$ = 100
    reward.price *= 100;
    return axios.post(`/projects/${projectId}/rewards`, reward);
  },
  editReward(projectId, data) {
    const reward = Object.assign({}, data);
    // reward price is stored on backend in the smallest sub-division of the currency, eg: 1$ = 100
    reward.price *= 100;
    return axios.patch(`/projects/${projectId}/rewards/${reward.id}`, reward);
  },
  destroyReward(projectId, id) {
    return axios.delete(`/projects/${projectId}/rewards/${id}`);
  },
  getRewards(id, succ) {
    axios.get(`/projects/${id}/rewards`).then((response) => {
      // reward price is stored on backend in the smallest sub-division of the currency, eg: 1$ = 100
      response.data.forEach((contribution) => {
        contribution.price /= 100;
      });
      succ(response.data);
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/rewards.js